import React from 'react';
import classnames from 'classnames';
import BlogAddToFavouritesButton from '@gik/blog/components/BlogAddToFavouritesButton';
import Link from '@/components/Link';
import bemBlock from '@gik/core/utils/bemBlock';
import routes from '@gik/core/routes';

interface ArticleAuthorLinkProps extends React.HTMLAttributes<HTMLDivElement> {
  authorFullName: string;
  authorSlug: string;
  articleId: string;
}

export default function ArticleAuthorLink({
  authorFullName,
  authorSlug,
  articleId,
  className,
}: ArticleAuthorLinkProps): React.ReactElement {
  const child = <span className="author">BY {authorFullName.toUpperCase()}</span>;
  const authorContainer = authorSlug ? (
    <Link href={`/${routes.blog}/authors/${authorSlug}`}>
      <a>{child}</a>
    </Link>
  ) : (
    child
  );

  const bem = bemBlock('author-link');
  const blockClasses = classnames(bem(), className || '');
  return (
    <div className={blockClasses}>
      <BlogAddToFavouritesButton type="articles" typeId={articleId} />
      {authorContainer}
    </div>
  );
}
